import { LoginResponse } from "../../types";
import { baseUrl } from "./baseUrl";

export async function login(
  username: string,
  password: string
): Promise<LoginResponse> {
  try {
    const res = await fetch(
      `${baseUrl}/admin/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      }
    );

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(err?.message ?? `HTTP ${res.status}`);
    }

    return (await res.json()) as LoginResponse;
  } catch (error) {
    console.error("Error logging in:", (error as Error).message);
    throw error;
  }
}
